import { createStyles, makeStyles } from "@material-ui/core";
import {
    AreaNotificationMessage,
    Button,
    MarketResearchTool,
    MarketResearchType,
    MobilePage,
    MobilePageActions,
    MobilePageSection,
    RelodeTheme,
} from "@relode/core";
import * as React from "react";
import styled from "styled-components";

import {
    MarketResearchHelpSection,
    MarketResearchUpSellMarketingSection,
} from "../../../../src/shared/components";
import { useClientPublicMarketResearchContext } from "./_infra/clientPublicMarketResearchProvider";
import { ClientPublicMarketResearchProps } from "./clientPublicMarketResearchProps";

const useStyles = makeStyles(
    (theme: RelodeTheme) =>
        createStyles({
            marketResearchContainer: {
                padding: "16px",
            },
        }),
    { name: "MarketResearchMobile" }
);

export const ClientPublicMarketResearchMobile = (
    props: ClientPublicMarketResearchProps
) => {
    const classes = useStyles(props);

    const [state] = useClientPublicMarketResearchContext();
    const {
        searchResults,
        searchResults: {
            overview: { error, data: overviewData },
        },
    } = state;

    const { showMarketing, onSignIn } = props;

    const renderFooter = (): React.ReactNode => (
        <Button
            size="small"
            color="primary"
            variant="contained"
            fullWidth
            onClick={onSignIn}
        >
            sign in
        </Button>
    );

    if (error) {
        return (
            <MobilePage
                showTabs={false}
                busyType="bar"
                defaultSection="marketResearchMobileContainer"
                actions={<MobilePageActions title="market research failed" />}
                footerActions={renderFooter}
            >
                <MobilePageSection
                    id="marketResearchMobileContainer"
                    label="market research"
                >
                    <AreaNotificationContainer>
                        <AreaNotificationMessage level="error">
                            {error.friendlyMessages ? (
                                <>{error.friendlyMessages}</>
                            ) : (
                                <>
                                    The information you are looking for cannot
                                    be found. Contact support at{" "}
                                    <a
                                        href="mailto:support@relode.com"
                                        target="_blank"
                                    >
                                        support@relode.com
                                    </a>{" "}
                                    if you have any questions.
                                </>
                            )}
                        </AreaNotificationMessage>
                    </AreaNotificationContainer>
                </MobilePageSection>
            </MobilePage>
        );
    }

    return (
        <MobilePage
            showTabs={false}
            busyType="bar"
            defaultSection="marketResearchMobileContainer"
            actions={<MobilePageActions title={"market research"} />}
            footerActions={renderFooter}
        >
            <MobilePageSection
                id="marketResearchMobileContainer"
                label="market research"
            >
                <div className={classes.marketResearchContainer}>
                    {showMarketing ? (
                        <MarketResearchUpSellMarketingSection
                            jobManagerName={overviewData?.jobManager?.fullName}
                            jobManagerPhoneNumber={
                                overviewData?.jobManager?.phoneNumber
                            }
                            jobManagerEmail={overviewData?.jobManager?.email}
                        />
                    ) : null}
                    <MarketResearchTool
                        state={searchResults}
                        marketResearchType={MarketResearchType.PublicTool}
                        helpSection={<MarketResearchHelpSection />}
                    />
                </div>
            </MobilePageSection>
        </MobilePage>
    );
};

const AreaNotificationContainer = styled.div`
    margin-top: 16px;
`;
